module.exports = __webpack_public_path__ + "static/guild_artisan_mtg_clb-8379c397ba5982d08b3a8bee1d0b125a.webp";